import { useEffect, useState } from 'react';

import debounce from 'lodash.debounce';

import isFunction from 'utils/function';
import { isWeb } from 'utils/responsiveness';

export enum PinCloseKey {
    BACKSPACE = 'Backspace',
    ESCAPE = 'Escape',
}

function useKeyboardCloseHandler(onKeyPress?: () => void) {
    const [keypressValue, setKeypressValue] = useState('');
    const hanldePressActionDebounced = debounce(
        () => {
            if (isFunction(onKeyPress)) {
                onKeyPress();
            }
        },
        1000,
        { leading: true, trailing: false },
    );

    const handleKeyUpPress = (event: KeyboardEvent) => {
        if (
            Object.values(PinCloseKey).some((key) => key === event.key) &&
            !(event.key === PinCloseKey.BACKSPACE && keypressValue) &&
            isFunction(onKeyPress)
        ) {
            hanldePressActionDebounced();
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        } else {
            // @ts-ignore
            setKeypressValue(event.target?.value || '');
        }
    };

    useEffect(() => {
        if (isWeb) {
            document.addEventListener('keyup', handleKeyUpPress);
        }

        return () => {
            if (isWeb) {
                document.removeEventListener('keyup', handleKeyUpPress);
            }
        };
    }, [handleKeyUpPress]);
}

export default useKeyboardCloseHandler;
